import { Skeleton } from '@eombor/ui';
import { t } from '../../../shared/i18n/index.js';
import { DESKTOP_QUERY, useMediaQuery } from '../../../shared/ui/useMediaQuery.js';
import { SupplyItemCardsSkeleton } from './SupplyItemCards.js';

/**
 * YUKLANISH HOLATI — sahifaning O'Z shaklida.
 *
 * Ilgari bu yerda o'nta bir xil chiziq turardi (`<Skeleton lines={10} />`)
 * va ma'lumot kelganda sahifa butunlay boshqa tuzilmaga sakrardi:
 * sarlavha, meta qatori va toolbar birdan paydo bo'lib, jadvalni pastga
 * surib yuborardi.
 *
 * Endi o'rin egallaydigan shakl haqiqiysi bilan bir xil: sarlavha bloki,
 * to'rt maydonli meta, toolbar va 56px lik qatorlar. Kelgan ma'lumot
 * ularning ustiga TUSHADI, ularni surmaydi.
 */
export const SupplyDetailSkeleton = () => {
  const desktop = useMediaQuery(DESKTOP_QUERY);
  return (
    <div
      /* `aria-busy` — ekran o'qigich uchun: ichkaridagi bloklar `aria-hidden`
       va usiz sahifa unga butunlay bo'sh bo'lib eshitilardi. */
      role="status"
      aria-busy="true"
      aria-label={t('supply.linesCaption')}
      className="flex w-full flex-col gap-5"
    >
      <div className="flex flex-col gap-4">
        <Skeleton className="h-8 w-36" />

        <div className="flex flex-col gap-2">
          <Skeleton className="h-7 w-52" />
          <Skeleton className="h-4 w-72" />
        </div>

        <div className="flex flex-wrap gap-x-10 gap-y-4 rounded-[var(--radius-md)] border border-border bg-surface px-5 py-3.5">
          {Array.from({ length: 4 }, (_, i) => (
            <div key={i} className="flex flex-col gap-1.5">
              <Skeleton className="h-3 w-24" />
              <Skeleton className="h-4 w-20" />
            </div>
          ))}
        </div>
      </div>

      <div className="flex flex-col">
        <div className="flex flex-wrap items-center justify-between gap-3 rounded-t-[var(--radius-lg)] border border-border bg-surface px-4 py-3">
          <div className="flex items-center gap-2">
            <Skeleton className="h-8 w-28" />
            <Skeleton className="h-8 w-24" />
            <Skeleton className="h-8 w-32" />
          </div>
          <div className="flex items-center gap-2">
            <Skeleton className="h-10 w-56" />
            <Skeleton className="h-10 w-32" />
          </div>
        </div>

        {/* Telefonda — kartochkalar shaklida: kelgan ma'lumot ularning
          o'rniga tushadi, jadval qatoridan kartochkaga sakramaydi. */}
        {!desktop ? (
          <div className="mt-3">
            <SupplyItemCardsSkeleton />
          </div>
        ) : (
          <div className="rounded-b-[var(--radius-lg)] border border-t-0 border-border bg-surface">
            {Array.from({ length: 8 }, (_, i) => (
              <div
                key={i}
                className="flex h-14 items-center gap-4 border-b border-border px-4 last:border-b-0"
              >
                <Skeleton className="h-4 w-4" />
                <Skeleton className="h-4 w-8" />
                <Skeleton className="h-4 w-28" />
                <Skeleton className="h-4 flex-1" />
                <Skeleton className="h-4 w-16" />
                <Skeleton className="h-8 w-28" />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
